<template lang="html">
    <section class="delete-category">
        <h1>ERROR</h1>
        <div v-if="action.showResponseUse">
            <p>
                La suppression n'est pas autorisée car la categorie
                <strong style="color: red;">"{{ getTranslate(action.category.terms.name) }}"</strong> est déjà utilisée comme référence!
            </p>
            <button class="btn" @click.prevent="hideModal">Cancel</button>
        </div>

        <div v-if="!action.showResponseUse">
            <div v-if="showMsg">
                <p style="color: red"><strong>Impossible de supprimer cette categorie</strong></p>
            </div>
            <p>
                Êtes-vous sûr de vouloir supprimer <strong style="color: red;">"{{ getTranslate(action.category.terms.name) }}"</strong>
            </p>
            <button class="btn" @click.prevent="hideModal">Cancel</button>
            <button type="submit" class="btn" @click.prevent="deleteThisCat(action);">Delete</button>
        </div>
    </section>
</template>

<script lang="js">
import {mapActions} from 'vuex'
import httpService from '../../../../components/service'

export default {
    name: 'delete-category',
    props: [
        'action'
    ],
    mounted () {

    },
    data () {
        return {
            showMsg: false
        }
    },
    created () {

    },
    methods: {
        ...mapActions({
            listCatBySection: 'categories/listCatBySection'
        }),
        deleteThisCat: function (value) {
            httpService.delete('/admin/categories/' + value.category.id).then(response => {
                if (response.success) {
                    this.listCatBySection(parseInt(value.currentSections.id))
                    this.showMsg = false
                    this.$root.$emit('bv::hide::modal', 'defaultModal')
                } else {
                    console.error('...+ERROR DeleteCategory+....', response)
                    this.showMsg = true
                }
            })
        },
        /**
         * Function hide Modal
         */
        hideModal: function () {
            this.$root.$emit('bv::hide::modal', 'defaultModal')
        }
    },
    computed: {}
}
</script>

<style scoped lang="scss">
.delete-category {
}
</style>



// WEBPACK FOOTER //
// DeleteCategory.vue?448174e2